export const menuTitle = { title: "S2", label: "S2" }
  